module.exports = __webpack_public_path__ + "img/Cancha deportiva.11a8ada6.png";